import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-workflow-automation',
  imports: [RouterModule, FeatureHero],
  templateUrl: './workflow-automation.html',
  styleUrl: './workflow-automation.scss',
})
export class WorkflowAutomation {
  faqData = [
    { 
      title: 'What is incident management?', 
      content: 'Incidents can crop up at any time...' 
    },
    { 
      title: 'What are the benefits?', 
      benefits: ['Increased productivity', 'Consistent quality'] 
    }
  ];
}
